/* ASC-CUSTOM: theme-level interaction events (product cards, cart upsell, web vitals).
   Depends on assets/asc-track.js (window.asc.track). No personal data is sent. */
(function () {
  'use strict';
  function track(n, p, o) { try { if (window.asc && window.asc.track) window.asc.track(n, p, o); } catch (e) {} }

  /* Product card clicks (collection, home, search, recommendations) + home CTAs ([data-asc-cta]) */
  document.addEventListener('click', function (e) {
    var cta = e.target.closest && e.target.closest('[data-asc-cta]');
    if (cta) track('home_cta', { cta: cta.getAttribute('data-asc-cta'), href: cta.getAttribute('href') || '', list: location.pathname, how: cta.getAttribute('data-asc-how') || undefined });   /* how: Christmas hero v2, button | media (2026-10-31) */
    var a = e.target.closest && e.target.closest('a[href*="/products/"]');
    if (!a) return;
    var card = a.closest('product-card, .grid-view-item, .product-card');
    if (!card) return;
    var list = card.parentElement ? card.parentElement.querySelectorAll('product-card, .grid-view-item, .product-card') : [];
    var position = Array.prototype.indexOf.call(list, card) + 1;
    track('card_click', {
      handle: (window.asc && window.asc.handleOf(a)) || '',
      position: position > 0 ? position : undefined,
      list: location.pathname,
      has_video: !!card.querySelector('video'),
      has_rating: !!card.querySelector('.product-card__rating, .rating, .jdgm-prev-badge'),
      cta: a.classList.contains('asc-card-cta') ? 'personalize' : 'card'
    });
  }, true);

  /* Cart add-on offers (snippets/asc-at-cart-addons.liquid, 2026-09-25): which offers showed, what was added, which
     "Personalize" link was followed. */
  function upsell() {
    var wrap = document.querySelector('.asc-upsell');
    if (!wrap) return;
    track('cart_upsell_shown', {
      offers: Array.prototype.map.call(wrap.querySelectorAll('[data-at-offer]'), function (o) { return o.getAttribute('data-at-offer'); }).join('|')
    }, { once: true });
    Array.prototype.forEach.call(wrap.querySelectorAll('form[data-asc-upsell]'), function (f) {
      f.addEventListener('submit', function () {
        var picked = Array.prototype.filter.call(f.querySelectorAll('[data-at-handle]'), function (i) { return !i.disabled && (i.type !== 'radio' || i.checked); });
        track('cart_upsell_add', { offer: f.getAttribute('data-asc-upsell'), handles: picked.map(function (i) { return i.getAttribute('data-at-handle'); }).join('|') });
      });
    });
    Array.prototype.forEach.call(wrap.querySelectorAll('[data-at-offer-link]'), function (a) {
      a.addEventListener('click', function () { track('cart_upsell_click', { offer: a.getAttribute('data-at-offer-link'), href: a.getAttribute('href') || '' }); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', upsell); else upsell();

  /* Rush line opened (snippets/asc-at-rush.liquid; 2026-09-25). "toggle" does not bubble, so listen in the capture phase. */
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (d && d.matches && d.matches('details[data-at-rush]') && d.open) track('rush_info_open', { where: d.getAttribute('data-at-rush') }, { once: true });
  }, true);

  /* Arrival window for [data-asc-arrive] / ship date for [data-asc-ships] (PDP v4).
     Canonical promise: made to order in 3 business days, delivered in about 3–4 business days after shipping.
     Business days = Monday to Friday; delivery days also skip US carrier holidays (window.ASC_NO_DELIVERY in
     layout/theme.liquid, 2026-09-25). Display only; never used for pricing. */
  function arrival() {
    var nodes = document.querySelectorAll('[data-asc-arrive], [data-asc-ships]');
    if (!nodes.length) return;
    var off = window.ASC_NO_DELIVERY || [];
    function key(x) { return x.getFullYear() + '-' + ('0' + (x.getMonth() + 1)).slice(-2) + '-' + ('0' + x.getDate()).slice(-2); }
    function addBiz(d, n, hol) { d = new Date(d.getTime()); while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6 && !(hol && off.indexOf(key(d)) > -1)) n--; } return d; }
    function mon(d) { try { return d.toLocaleDateString('en-US', { month: 'short' }); } catch (e) { return ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][d.getMonth()]; } }
    function fmt(d) { return mon(d) + ' ' + d.getDate(); }
    function range(a, b) { return mon(a) === mon(b) ? mon(a) + ' ' + a.getDate() + '–' + b.getDate() : fmt(a) + ' – ' + fmt(b); }   // "Sep 14–15" / "Sep 30 – Oct 1"
    var today = new Date(); today.setHours(12, 0, 0, 0);
    /* 2026-09-13 (Murat): production is 1–3 business days → arrival window = earliest (1 + 3) to latest (3 + 4). */
    var shipEarly = addBiz(today, 1), ship = addBiz(today, 3), a1 = addBiz(shipEarly, 3, true), a2 = addBiz(ship, 4, true);
    Array.prototype.forEach.call(nodes, function (n) {
      if (n.hasAttribute('data-asc-arrive')) n.textContent = range(a1, a2);
      else n.textContent = fmt(ship);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrival); else arrival();

  /* Hero video (sections/asc-hero-v5.liquid): one <video data-asc-hero-video> with no src in the HTML.
     Starts 1.5 s after the load event (or 6 s after DOMContentLoaded at the latest), picks the 720p source under 750px and
     the 1080p source above, and never starts on Save-Data, 2g/3g connections or prefers-reduced-motion. The <picture>
     underneath stays as the poster until the first frame plays (.is-playing fades the video in). LCP backlog A.1. */
  function heroVideo() {
    var v = document.querySelector('video[data-asc-hero-video]');
    if (!v) return;
    try {
      if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var c = navigator.connection || {};
      if (c.saveData) return;
      if (c.effectiveType && /(^|-)(2g|3g)$/.test(c.effectiveType)) return;
      if ((typeof c.downlink === 'number' && c.downlink < 1.5) || (typeof c.rtt === 'number' && c.rtt > 300)) return; /* slow 4G: keep the poster, skip the 4.6 MB clip */
    } catch (e) {}
    var started = false;
    function start() {
      if (started) return; started = true;
      var mobile = window.matchMedia && matchMedia('(max-width: 749px)').matches;
      var src = mobile ? v.getAttribute('data-src-mobile') : v.getAttribute('data-src-desktop');
      if (!src) return;
      v.addEventListener('playing', function () { v.classList.add('is-playing'); track('hero_video', { src: mobile ? 'mobile' : 'desktop' }, { once: true }); }, { once: true });
      var hd = v.getAttribute('data-src-mobile-hd');
      if (mobile && hd && hd !== src) v.addEventListener('error', function () { if (v.src !== hd) { v.src = hd; var q = v.play(); if (q && q.catch) q.catch(function () {}); } }, { once: true });
      v.muted = true; v.src = src;
      var p = v.play(); if (p && p.catch) p.catch(function () {});
    }
    if (document.readyState === 'complete') setTimeout(start, 1500);
    else { addEventListener('load', function () { setTimeout(start, 1500); }); setTimeout(start, 6000); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', heroVideo); else heroVideo();

  /* Web vitals (LCP, CLS, INP) without a library; one event per metric at page hide */
  try {
    var lcp = 0, lcpEl = '', cls = 0, inp = 0, inpEl = '';
    function sel(el) {
      if (!el || !el.tagName) return '';
      var s = el.tagName.toLowerCase();
      if (el.id) s += '#' + el.id;
      else if (el.className && typeof el.className === 'string') s += '.' + el.className.trim().split(/\s+/).slice(0, 2).join('.');
      return s.slice(0, 100);
    }
    new PerformanceObserver(function (l) {
      l.getEntries().forEach(function (en) { lcp = en.startTime; lcpEl = sel(en.element); });
    }).observe({ type: 'largest-contentful-paint', buffered: true });
    new PerformanceObserver(function (l) {
      l.getEntries().forEach(function (en) { if (!en.hadRecentInput) cls += en.value; });
    }).observe({ type: 'layout-shift', buffered: true });
    try {
      new PerformanceObserver(function (l) {
        l.getEntries().forEach(function (en) { if (en.interactionId && en.duration > inp) { inp = en.duration; inpEl = sel(en.target); } });
      }).observe({ type: 'event', buffered: true, durationThreshold: 40 });
    } catch (e) {}
    var sent = false;
    function rate(v, good, poor) { return v <= good ? 'good' : v <= poor ? 'needs_improvement' : 'poor'; }
    function report() {
      if (sent) return; sent = true;
      if (lcp) track('web_vital', { metric: 'LCP', value: Math.round(lcp), rating: rate(lcp, 2500, 4000), element: lcpEl });
      track('web_vital', { metric: 'CLS', value: Math.round(cls * 1000) / 1000, rating: rate(cls, 0.1, 0.25) });
      if (inp) track('web_vital', { metric: 'INP', value: Math.round(inp), rating: rate(inp, 200, 500), element: inpEl });
    }
    document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') report(); });
    addEventListener('pagehide', report);
  } catch (e) {}

  /* Judge.me: imported reviews carry the reviewer name "Etsy customer"; the site never names marketplaces
     (docs/PROMISE.md). Relabels the text in every Judge.me widget (carousel, PDP widget, pop-ups) as they render. */
  try {
    var jdgmRoots = '.jdgm-carousel-wrapper, .jdgm-carousel-popup, .jdgm-widget, .jdgm-rev, .jdgm-notification, .jdgm-preview-badge';
    var jdgmQueued = false;
    function jdgmFix() {
      jdgmQueued = false;
      var nodes = document.querySelectorAll(jdgmRoots);
      for (var i = 0; i < nodes.length; i++) {
        var w = document.createTreeWalker(nodes[i], NodeFilter.SHOW_TEXT), n;
        while ((n = w.nextNode())) {
          if (n.nodeValue && /Etsy customer|Sign in with Apple user/.test(n.nodeValue)) n.nodeValue = n.nodeValue.replace(/Etsy customer|Sign in with Apple user/g, 'Verified buyer');
        }
      }
    }
    function jdgmSchedule() { if (!jdgmQueued) { jdgmQueued = true; requestAnimationFrame(jdgmFix); } }
    function jdgmInit() { jdgmFix(); new MutationObserver(jdgmSchedule).observe(document.body, { childList: true, subtree: true, characterData: true }); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', jdgmInit); else jdgmInit();
  } catch (e) {}

  /* 2026-09-27: crossword badge text during Black Friday week by the visitor's clock (snippets/badge.liquid renders it
     at page-render time; cached pages may be older). Same window as the scheduled automatic discounts. */
  try {
    var bfNow = Date.now() / 1000, bf = bfNow >= 1795417200 && bfNow < 1796108340;
    var bfFix = function () {
      var b = document.querySelectorAll('[data-asc-bf-badge]');
      for (var i = 0; i < b.length; i++) b[i].textContent = bf ? 'Buy 2 · save 10%' : 'Buy 2 · save 5%';
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bfFix); else bfFix();
  } catch (e) {}
})();
